// extracted by mini-css-extract-plugin
export default {"root":"GettingStartedContent-module--root--657b2","card":"GettingStartedContent-module--card--b6acf","embedContainer":"GettingStartedContent-module--embedContainer--62019"};